import { Box } from "@mui/material";
import { EditIcon, DeleteIcon } from "../../../../../2_ksbHub/icons/icons";
import KsbActionButton from "../../../../../2_ksbHub/components/KsbActionButton";
import { useTheme } from "@mui/material/styles";

export default function RoomActions({ room, isAdmin, onEdit, onDelete }) {
  const theme = useTheme();

  if (!isAdmin) return null;

  return (
    <Box
      sx={{
        mt: 1.5,
        display: "flex",
        justifyContent: "flex-end",
        gap: 1,
      }}
    >
      <KsbActionButton
        onClick={(e) => {
          e.stopPropagation(); // ✅ prevents RoomDialog
          onEdit(room);
        }}
        icon={<EditIcon />}
        label="Raum bearbeiten"
        size="small"
        sx={{
          bgcolor: theme.palette.primary.main,
          "&:hover": { bgcolor: theme.palette.primary.dark },
        }}
      />
      <Box
        onClick={(e) => e.stopPropagation()} // ✅ blocks EVERYTHING inside
      >
        <KsbActionButton
          onClick={() => onDelete(room.id)}
          icon={<DeleteIcon />}
          label="Löschen"
          size="small"
          confirm={{
            title: "Raum löschen?",
            message: "Soll dieser Raum wirklich gelöscht werden?",
          }}
          sx={{
            bgcolor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
            "&:hover": { bgcolor: theme.palette.error.dark },
          }}
        />
      </Box>
    </Box>
  );
}
